import React from "react";

const VARIANTS = {
  primary:
    "bg-blue-600 text-white font-bold rounded-full flex items-center justify-center gap-2 touch-manipulation active:bg-blue-700 disabled:opacity-50",
  ghost:
    "text-sm text-gray-500 flex items-center gap-1 py-1 touch-manipulation",
  menu: "touch-manipulation active:bg-gray-50",
  "destructive-row":
    "w-full flex items-center gap-3 px-4 sm:px-5 py-3.5 sm:py-4 min-h-[48px] border-b border-gray-100 touch-manipulation",
};

export default function AppButton({
  variant = "primary",
  fullWidth = true,
  disabled = false,
  type = "button",
  className = "",
  children,
  ...rest
}) {
  const widthClass = fullWidth ? "w-full" : "";
  const classes = [
    VARIANTS[variant] || VARIANTS.primary,
    widthClass,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} disabled={disabled} className={classes} {...rest}>
      {children}
    </button>
  );
}
